import React, { useState } from "react";
import { Chip, Tooltip } from "@mui/material";
import { capitalize } from "lodash";

import { formatLocalDateTime } from "utils/date";
import { useSelector } from "react-redux";

import {
  POST_GRID_PRINT_MAIL_API_STATUS,
  REMINDER_LOG_PHONE_TYPE,
  REMINDER_LOG_STATUS_COLOR_MAP,
  REMINDER_LOG_TYPE,
} from "static/constants";
import useDebounce from "app/hooks/useDebounce";
import { useGetPatientReminderHistoryQuery } from "app/store/patient/api/patientApi";

const useSubscriptionLogTable = (type) => {
  const { patientId } = useSelector((state) => state.transmission);
  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });

  const onSearchChange = useDebounce((value) => {
    setSearch(value || undefined);
  }, 1500);

  const { data, isLoading, isFetching } = useGetPatientReminderHistoryQuery({
    patientId,
  });

  const columns = [
    {
      header: "Type",
      accessorkey: "type",
      filtervariant: "text",
      Cell: ({ row }) => {
        const rowData = row?.original;
        const message = rowData?.message || rowData?.error_message;
        const communicationType = rowData?.type || rowData?.communication_type;

        return (
          <div>
            <Tooltip
              style={{ fontSize: "14px", width: "300px" }}
              title={message}
              placement="bottom"
            >
              <div>{REMINDER_LOG_TYPE[communicationType]?.toUpperCase()}</div>
            </Tooltip>
          </div>
        );
      },
    },
    {
      header: "Reminder Type",
      accessorkey: "reminder_type",
      filtervariant: "text",
      Cell: ({ row }) => {
        const rowData = row?.original;
        return <div>{rowData?._id?.reminder_type ?? "Letter"}</div>;
      },
    },
    {
      header: "Phone Type",
      accessorKey: "phone",
      filterVariant: "text",
      Cell: ({ row }) => {
        const rowData = row?.original;
        return (
          <div>
            <div
              style={{
                width: "280px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {rowData?.phone_type
                ? REMINDER_LOG_PHONE_TYPE[rowData?.phone_type]
                : "—"}
            </div>
          </div>
        );
      },
    },
    {
      header: "Status",
      accessorkey: "status",
      filtervariant: "text",
      Cell: ({ row }) => {
        const rowData = row?.original;
        const postgridLogStatus =
          rowData?.print_mail_response?.status ||
          rowData?.address_verification_response?.status;

        const twilioLogStatus = rowData?.status;

        const status =
          twilioLogStatus || postgridLogStatus || rowData?.error_status;

        const color = REMINDER_LOG_STATUS_COLOR_MAP[status];

        return (
          <Chip
            variant="outlined"
            color={color}
            label={
              rowData?.type === "letter"
                ? POST_GRID_PRINT_MAIL_API_STATUS[status]
                : capitalize(status)
            }
          />
        );
      },
    },
    {
      header: "Created By",
      accessorkey: "created_by",
      filtervariant: "text",
      Cell: ({ row }) => {
        const rowData = row?.original;
        return capitalize(rowData?.created_by);
      },
    },
    {
      header: "Created At",
      accessorkey: "created_at",
      filtervariant: "text",
      Cell: ({ row }) => {
        const rowData = row?.original;
        return formatLocalDateTime(rowData?._id?.created_at);
      },
    },
    {
      header: "Updated At",
      accessorkey: "updated_at",
      filtervariant: "text",
      Cell: ({ row }) => {
        const rowData = row?.original;
        return formatLocalDateTime(rowData?._id?.updated_at);
      },
    },
  ];

  return {
    columns,
    isLoading,
    isFetching,

    data,
    pagination,
    search,

    setPagination,
    onSearchChange,
  };
};

export default useSubscriptionLogTable;
